import { apiFetchWithoutAuth, api } from "../utils/api";
import type { ChainId, IntegrationId } from "@KassaroAB/shared/types/ids";

export const completeShopifyOAuthApi = async (body: {
  code: string;
  shop: string;
  state: string;
}): Promise<void> => {
  return apiFetchWithoutAuth("callback/shopify/oauth2", {
    method: "POST",
    body,
  });
};

export const getShopifyOauthUrlApi = async (
  chainId: ChainId,
  shopDomain: string,
  integrationId?: IntegrationId,
): Promise<{ url: string }> => {
  const params = new URLSearchParams();
  params.set("shop", shopDomain);
  if (integrationId) {
    params.set("integrationId", integrationId);
  }
  return api.get(
    `chains/${chainId}/integrations/shopify/oauth2?${params.toString()}`,
  );
};
